// Sentry + PostHog are loaded lazily on idle to keep them out of the
// critical-path bundle. No app code depends on them synchronously
// (PostHog autocapture + Sentry global error handling only).

type IdleCb = () => void;

function scheduleIdle(cb: IdleCb): void {
  const w = window as Window & {
    requestIdleCallback?: (cb: IdleCb, opts?: { timeout: number }) => number;
  };
  if (typeof w.requestIdleCallback === "function") {
    w.requestIdleCallback(cb, { timeout: 2000 });
    return;
  }
  setTimeout(cb, 1);
}

let started = false;

export function initObservability(): void {
  if (started) return;
  started = true;

  if (import.meta.env.PROD) {
    scheduleIdle(() => {
      void import("@sentry/react")
        .then((Sentry) => {
          Sentry.init({
            dsn: "https://493ca49cf3086e3d3ab82c953f6c4350@o4511071659098112.ingest.us.sentry.io/4511071660670976",
            sendDefaultPii: true,
            integrations: [
              Sentry.browserTracingIntegration(),
              Sentry.replayIntegration(),
            ],
            tracesSampleRate: 0.1,
            replaysSessionSampleRate: 0.1,
            replaysOnErrorSampleRate: 1.0,
          });
        })
        .catch(() => {
          // observability is best-effort; never break the app
        });
    });
  }

  scheduleIdle(() => {
    const apiKey = import.meta.env.VITE_PUBLIC_POSTHOG_KEY as string | undefined;
    const apiHost = import.meta.env.VITE_PUBLIC_POSTHOG_HOST as string | undefined;
    if (!apiKey) return;

    void import("posthog-js")
      .then(({ default: posthog }) => {
        posthog.init(apiKey, {
          api_host: apiHost,
          defaults: "2026-01-30",
        });
      })
      .catch(() => {
        // best-effort
      });
  });
}
